import React from "react";
import {
  CarouselProvider,
  Slider,
  Slide,
  ButtonBack,
  ButtonNext,
} from "pure-react-carousel";
import "pure-react-carousel/dist/react-carousel.es.css";
import Divider from "./divider";

export default function () {
  return (
    <div id="gallery" className="relative bg-gray-300 pt-8 pb-6">
      <div
        className="bottom-auto top-0 left-0 right-0 w-full absolute pointer-events-none overflow-hidden -mt-20"
        style={{ height: "80px", transform: "translateZ(0)" }}
      >
        <svg
          className="absolute bottom-0 overflow-hidden"
          xmlns="http://www.w3.org/2000/svg"
          preserveAspectRatio="none"
          version="1.1"
          viewBox="0 0 2560 100"
          x="0"
          y="0"
        >
          <polygon
            className="text-gray-300 fill-current"
            points="2560 0 2560 100 0 100"
          ></polygon>
        </svg>
      </div>
      <div className="container mx-auto px-4">
        <div className="flex relative justify-center">
          <h2 className="text-6xl text-center font-semibold text-gray-800">
            Our Gallery
          </h2>
          <div className="absolute -bottom-4 left-1/2 -translate-x-1/2 transform w-80 h-3 bg-red-500"></div>
        </div>
      </div>
      <div className="container mt-16 mx-auto px-8 relative">
        <CarouselProvider
          naturalSlideWidth={100}
          naturalSlideHeight={50}
          totalSlides={3}
        >
          <Slider>
            <Slide index={0}>
              <img
                className="w-full object-cover object-center"
                src="https://images.unsplash.com/photo-1522202176988-66273c2fd55f?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1051&q=80"
              />
            </Slide>
            <Slide index={1}>
              <img
                className="w-full object-cover object-center"
                src="https://images.unsplash.com/photo-1522202176988-66273c2fd55f?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1051&q=80"
              />
            </Slide>
            <Slide index={2}>
              <img
                className="w-full object-cover object-center"
                src="https://images.unsplash.com/photo-1522202176988-66273c2fd55f?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1051&q=80"
              />
            </Slide>
          </Slider>
          <div className="absolute left-0 -bottom-12 ml-8">
            <ButtonBack>
              <i className="fas fa-angle-double-left text-8xl"></i>
            </ButtonBack>
          </div>
          <div className="absolute right-0 -bottom-12 mr-8">
            <ButtonNext>
              <i className="fas fa-angle-double-right text-8xl"></i>
            </ButtonNext>
          </div>
        </CarouselProvider>
      </div>
      <Divider />
    </div>
  );
}
